import { observable, action } from 'mobx';
import { setMetaTag } from '~/utils/device.utils';

export enum MobilePreviewMode {
    DESKTOP = 'desktop',
    MOBILE = 'mobile'
}

export const DESKTOP_META_TAG = 'width=1024';
const MOBILE_META_TAG = 'width=device-width, initial-scale=1, maximum-scale=1';

// TODO: This is only builder state, need to move to builder ui store
export class MobileStore {
    @observable mobilePreviewMode: MobilePreviewMode = null;
    @observable isOnboardingPreview: boolean = false;

    @action.bound
    setIsOnboardingPreview(value: boolean) {
        this.isOnboardingPreview = value;
    }

    @action.bound
    setMobilePreviewMode(mode = null) {
        this.mobilePreviewMode = mode;
        const metaValue =
            mode === MobilePreviewMode.DESKTOP
                ? DESKTOP_META_TAG
                : MOBILE_META_TAG;
        setMetaTag('viewport', 'content', metaValue);
    }
}
